// src/components/restaurant/menu/SimpleMenuForm.jsx
import React, { useRef } from "react";
import MenuForm from "./MenuFormStaff";
import api from "../../../utils/api";
import { toast } from "react-toastify";
import { useSubcategories } from "../../../hooks/useSubcategories";
import { showToast } from "../../../helper/generalHelper";
import MenuFormEdit from "./MenuFormEditStaff";
import { useNavigate } from "react-router-dom";

// const token = localStorage.getItem("token");

const SimpleMenuFormEditStaff = ({ inventory, menuData }) => {
  const { subcategories } = useSubcategories();
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const isEdit = !!menuData?.id;

  const handleSubmit = async () => {
    const sanitizedMenu = menuRef.current?.getSanitizedData();
    const uploads = menuRef.current?.getUploads?.() || [];

    if (!sanitizedMenu) {
      toast.error("Please fill in all required fields.");
      return;
    }

    const payload = {
      menus: [sanitizedMenu],
      // uploads: uploads,
      uploads:[],
    };

    console.log("Simple Form Payload:", payload);

    try {
      const res = isEdit
        ? await api.put(
            `restaurant-staff/restaurant/menu/update`,
            payload
          )
        : await api.post("restaurant-staff/restaurant/menu/new", payload);

      showToast(res);
      if (res.success) {
        setTimeout(() => {
          navigate("/restaurant-staff/employee/menu/items");
        }, 1500);
      }
    } catch (err) {
      console.error(err);
      toast.error("Submission failed.");
    }
  };

  return (
    <>
      <MenuFormEdit
        ref={menuRef}
        categories={subcategories}
        inventory={inventory}
        initialData={menuData} // Pass menuData to prefill values
        hideDelete // Optional
      />

      <div className="flex justify-end mt-4">
        <button
          onClick={handleSubmit}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          {isEdit ? "Update" : "Submit"}
        </button>
      </div>
    </>
  );
};

export default SimpleMenuFormEditStaff;
